import React from "react";
import { getWidgetType, isMobile } from "../../utils/general";

function WidgetList(props) {
  const handleWidgetClick = (item) => {
    if (props.handleWidgetClick) {
      // Use click-to-place mode
      props.handleWidgetClick(item.type);
    } else if (props.addPositionOfSignature) {
      // Fallback to original onclick behavior
      props.addPositionOfSignature("onclick", item);
    }
  };

  return (
    <div className="grid grid-cols-1 gap-0 py-4 px-2">
      {props.updateWidgets.map((item, ind) => {
        const isSelected =
          props.clickToPlaceMode && props.selectedWidgetType === item.type;
        return (
          <div key={ind} className="w-full">
            <div
              data-tut="isSignatureWidget"
              className={`select-none cursor-pointer`}
              onClick={() => handleWidgetClick(item)}
              ref={(element) => !isMobile && item.ref(element)}
              onMouseMove={(e) => !isMobile && props?.handleDivClick(e)}
              onMouseDown={() => !isMobile && props?.handleMouseLeave()}
              onTouchStart={(e) => !isMobile && props?.handleDivClick(e)}
            >
              {item.ref && getWidgetType(item, item.name, isSelected)}
            </div>
          </div>
        );
      })}

      {/* Show cancel button when in click-to-place mode */}
      {props.clickToPlaceMode && (
        <div className="mt-2">
          <button
            onClick={props.cancelClickToPlaceMode}
            className="w-full px-3 py-2 text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
          >
            Cancel Click-to-Place Mode
          </button>
        </div>
      )}
    </div>
  );
}

export default WidgetList;
